/**
 * ProgressBar Component
 *
 * Linear progress bar for mobile onboarding flow.
 * Shows visual progress through multi-step wizard.
 */

import React from "react";
import { cn } from "../utils/cn";

export interface ProgressBarProps {
  /** Current step (0-indexed) */
  current: number;
  /** Total number of steps */
  total: number;
  /** Optional additional class names */
  className?: string;
}

/**
 * ProgressBar — Mobile linear progress indicator
 *
 * Replaces ProgressDots on mobile for better visual feedback.
 * Uses a filled track that grows proportionally to the current step.
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  className,
}) => {
  const percentage = ((current + 1) / total) * 100;

  return (
    <div className={cn("progress-bar-container", className)}>
      <span
        className="progress-bar-label"
        id="progress-bar-label"
      >{`Step ${current + 1} of ${total}`}</span>
      <div
        className="progress-bar-track"
        id="progress-bar-track"
        role="progressbar"
        aria-valuenow={current + 1}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={`Step ${current + 1} of ${total}`}
      >
        <div
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
